"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Banner = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _ursaIcons = require("@smartsheet/ursa-icons");
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../theme/utils/useTheme");
var _BannerContext = require("./components/BannerContext");
var _BannerIconContainer = require("./styled/BannerIconContainer");
var _BannerStyled = require("./styled/BannerStyled");
const presets = {
  error: {
    iconComponent: /*#__PURE__*/_react.default.createElement(_ursaIcons.AlertErrorFilledIcon, {
      size: 24,
      color: "currentColor"
    })
  },
  success: {
    iconComponent: /*#__PURE__*/_react.default.createElement(_ursaIcons.SuccessFilledIcon, {
      size: 24,
      color: "currentColor"
    })
  },
  warning: {
    iconComponent: /*#__PURE__*/_react.default.createElement(_ursaIcons.WarningFilledIcon, {
      size: 24,
      color: "currentColor"
    })
  },
  info: {
    iconComponent: /*#__PURE__*/_react.default.createElement(_ursaIcons.InfoFilledIcon, {
      size: 24,
      color: "currentColor"
    })
  }
};
const getIcon = function (type) {
  let overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let icon = arguments.length > 2 ? arguments[2] : undefined;
  //TODO: V5-remove components
  if (overrides.Icon === null || icon === null) {
    return null;
  }
  if (icon) {
    return icon;
  } else if (overrides.Icon) {
    return /*#__PURE__*/_react.default.createElement(overrides.Icon, null);
  } else {
    return presets[type].iconComponent;
  }
};
const Banner = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    type,
    components = {},
    clientId,
    icon,
    ...rest
  } = _ref;
  if (process.env.NODE_ENV !== "production") {
    //TODO: V5-remove
    if (components.Icon) {
      console.warn("The 'components.Icon' prop has been deprecated in favor of the 'icon' prop. Please use that instead.");
    }
  }
  const resolvedIcon = getIcon(type, components, icon);
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const memoizedBannerContextValue = (0, _react.useMemo)(() => ({
    type
  }), [type]);
  return /*#__PURE__*/_react.default.createElement(_BannerContext.BannerContextProvider, {
    value: memoizedBannerContextValue
  }, /*#__PURE__*/_react.default.createElement(_BannerStyled.BannerStyled, (0, _extends2.default)({
    type: type,
    role: "alert",
    "data-client-id": clientId,
    "aria-live": "polite",
    tabIndex: 0,
    ref: ref,
    themeMode: themeMode
  }, rest), resolvedIcon && /*#__PURE__*/_react.default.createElement(_BannerIconContainer.BannerIconContainer, {
    "aria-hidden": true,
    themeMode: themeMode,
    type: type
  }, resolvedIcon), children));
});
exports.Banner = Banner;
Banner.displayName = "Banner";
//# sourceMappingURL=Banner.js.map